import { createContext } from 'react'

import { createMemberBankListStore } from '../store/createStore'

export const MemberBankListStoreContext = createContext<
  ReturnType<typeof createMemberBankListStore> | undefined
>(undefined)
